import React, { useState } from "react";
import { RefCard, RangeIcon } from "../betTablePoker/refParts";
import { bookClass, isOpen, bySr, getExposureFrom } from "../betTablePoker/refUtils";
import { formatBook } from "../../../utils/formatOdds";

const REMARK_ICON = `${import.meta.env.BASE_URL}assets/img/icons/remark.png`;

/**
 * Poker 6 Players (poker6) bet table in the reference admin's markup — rendered inside `.casino-detail`:
 *   .poker-result-board (when the feed has rdesc "winner||pattern")
 *   .d-none-small > .casino-box > .teen1daycasino-container >
 *     .teen1dayleft (h4 Hands + 6 × .casino-col-container: player cards [i-1, i+5] + odds + book)
 *     .teen1daycenter · .teen1dayright.pattern (h4 Pattern + 9 patterns, last 3 .fullbox)
 *   .casino-remark (when the feed has a remark)
 * Markets like the reference: main = sub subtype "poker6" ordered by sr (0-5 hands, 6-14 patterns).
 * Styled by the ported reference rules in styles/index.css (.poker6player ...).
 */
export default function BetTablePoker6({ data = [], cards = [], rdesc, remark, onBetClick, exposures = {} }) {
  const [openRange, setOpenRange] = useState({});
  const toggle = (id) => setOpenRange((s) => ({ ...s, [id]: !s[id] }));

  const main = bySr((Array.isArray(data) ? data : []).filter((m) => m?.subtype === "poker6"));

  const click = (m) => {
    if (!m || !isOpen(m)) return;
    onBetClick?.(m.b, m.nat, m);
  };
  const book = (m) => {
    const exp = getExposureFrom(exposures, m?.nat);
    return <div className={`casino-book text-center w-100 ${bookClass(exp)}`}>{formatBook(exp)}</div>;
  };
  const range = (id, m) => (
    <div className="float-right">
      <RangeIcon id={id} market={m} open={!!openRange[id]} onToggle={toggle} />
    </div>
  );

  const [winText, patternText] = rdesc ? String(rdesc).split("||") : [];

  return (
    <>
      {rdesc ? (
        <div className="poker-result-board">
          <div className="d-inline-block">
            <div className="d-inline-block">
              <span>{winText}</span>
            </div>
          </div>{" "}
          <div className="d-inline-block ml-2">
            <b>{patternText}</b>
          </div>
        </div>
      ) : null}{" "}
      <div className="d-none-small">
        <div className="casino-box">
          <div className="teen1daycasino-container">
            <div className="teen1dayleft">
              <h4 className="playera">Hands</h4>{" "}
              <div className="casino-row-container">
                {[1, 2, 3, 4, 5, 6].map((s) => {
                  const m = main[s - 1];
                  return (
                    <div key={`hands-${s}`} className="casino-col-container">
                      <div className="casino-box-row">
                        <div className="w-100 mb-1 pr">
                          <b>{m?.nat}</b> {range(`hands-${s - 1}`, m)}
                        </div>{" "}
                        <div className={`poker6box${isOpen(m) ? "" : " suspended"}`} onClick={() => click(m)}>
                          <div className="casino-nation-name">
                            <div>
                              <span className="player-card">
                                <RefCard card={cards[s - 1]} />
                              </span>{" "}
                              <span className="player-card">
                                <RefCard card={cards[s + 5]} />
                              </span>
                            </div>{" "}
                            <span className="float-right mr-1">
                              <b className="d-block text-right">{m?.b}</b>
                            </span>
                          </div>
                        </div>{" "}
                        {book(m)}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>{" "}
            <div className="teen1daycenter" />{" "}
            <div className="teen1dayright pattern">
              <h4>Pattern</h4>{" "}
              <div className="casino-row-container">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((s) => {
                  const m = main[s + 5];
                  return (
                    <div key={`pattern-${s}`} className={`casino-col-container${s >= 7 ? " fullbox" : ""}`}>
                      <div className="casino-box-row">
                        <div className="w-100 mb-1 pr">{range(`pattern-${s + 5}`, m)}</div>{" "}
                        <div className={`poker6box${isOpen(m) ? "" : " suspended"}`} onClick={() => click(m)}>
                          <div className="casino-nation-name">
                            <b>{m?.nat}</b>{" "}
                            <span className="d-block text-right">
                              <b>{m?.b}</b>
                            </span>
                          </div>
                        </div>{" "}
                        {book(m)}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
      {remark != null && remark !== "" && (
        <div className="casino-remark mt-3">
          <div className="remark-icon">
            <img src={REMARK_ICON} alt="" />
          </div>{" "}
          {React.createElement("marquee", null, remark)}
        </div>
      )}
    </>
  );
}
